const emojiList = [
  {
    value: "[大笑]",
    regexp: "\\[大笑\\]",
    url: require("@/assets/emoji/emoji_00.png"),
    name: "大笑",
  },
  {
    value: "[可爱]",
    regexp: "\\[可爱\\]",
    url: require("@/assets/emoji/emoji_01.png"),
    name: "可爱",
  },
  {
    value: "[色]",
    regexp: "\\[色\\]",
    url: require("@/assets/emoji/emoji_02.png"),
    name: "色",
  },
  {
    value: "[嘘]",
    regexp: "\\[嘘\\]",
    url: require("@/assets/emoji/emoji_03.png"),
    name: "嘘",
  },
  {
    value: "[亲]",
    regexp: "\\[亲\\]",
    url: require("@/assets/emoji/emoji_04.png"),
    name: "亲",
  },
  {
    value: "[呆]",
    regexp: "\\[呆\\]",
    url: require("@/assets/emoji/emoji_05.png"),
    name: "呆",
  },
  {
    value: "[口水]",
    regexp: "\\[口水\\]",
    url: require("@/assets/emoji/emoji_06.png"),
    name: "口水",
  },
  {
    value: "[呲牙]",
    regexp: "\\[呲牙\\]",
    url: require("@/assets/emoji/emoji_07.png"),
    name: "呲牙",
  },
  {
    value: "[鬼脸]",
    regexp: "\\[鬼脸\\]",
    url: require("@/assets/emoji/emoji_08.png"),
    name: "鬼脸",
  },
  {
    value: "[害羞]",
    regexp: "\\[害羞\\]",
    url: require("@/assets/emoji/emoji_09.png"),
    name: "害羞",
  },
  {
    value: "[偷笑]",
    regexp: "\\[偷笑\\]",
    url: require("@/assets/emoji/emoji_10.png"),
    name: "偷笑",
  },
  {
    value: "[调皮]",
    regexp: "\\[调皮\\]",
    url: require("@/assets/emoji/emoji_11.png"),
    name: "调皮",
  },
  {
    value: "[可怜]",
    regexp: "\\[可怜\\]",
    url: require("@/assets/emoji/emoji_12.png"),
    name: "可怜",
  },
  {
    value: "[敲]",
    regexp: "\\[敲\\]",
    url: require("@/assets/emoji/emoji_13.png"),
    name: "敲",
  },
  {
    value: "[惊讶]",
    regexp: "\\[惊讶\\]",
    url: require("@/assets/emoji/emoji_14.png"),
    name: "惊讶",
  },
  {
    value: "[流感]",
    regexp: "\\[流感\\]",
    url: require("@/assets/emoji/emoji_15.png"),
    name: "流感",
  },
  {
    value: "[委屈]",
    regexp: "\\[委屈\\]",
    url: require("@/assets/emoji/emoji_16.png"),
    name: "委屈",
  },
  {
    value: "[流泪]",
    regexp: "\\[流泪\\]",
    url: require("@/assets/emoji/emoji_17.png"),
    name: "流泪",
  },
  {
    value: "[嚎哭]",
    regexp: "\\[嚎哭\\]",
    url: require("@/assets/emoji/emoji_18.png"),
    name: "嚎哭",
  },
  {
    value: "[惊恐]",
    regexp: "\\[惊恐\\]",
    url: require("@/assets/emoji/emoji_19.png"),
    name: "惊恐",
  },
  {
    value: "[怒]",
    regexp: "\\[怒\\]",
    url: require("@/assets/emoji/emoji_20.png"),
    name: "怒",
  },
  {
    value: "[酷]",
    regexp: "\\[酷\\]",
    url: require("@/assets/emoji/emoji_21.png"),
    name: "酷",
  },
  {
    value: "[不说]",
    regexp: "\\[不说\\]",
    url: require("@/assets/emoji/emoji_22.png"),
    name: "不说",
  },
  {
    value: "[鄙视]",
    regexp: "\\[鄙视\\]",
    url: require("@/assets/emoji/emoji_23.png"),
    name: "鄙视",
  },
  {
    value: "[阿弥陀佛]",
    regexp: "\\[阿弥陀佛\\]",
    url: require("@/assets/emoji/emoji_24.png"),
    name: "阿弥陀佛",
  },
  {
    value: "[奸笑]",
    regexp: "\\[奸笑\\]",
    url: require("@/assets/emoji/emoji_25.png"),
    name: "奸笑",
  },
  {
    value: "[睡着]",
    regexp: "\\[睡着\\]",
    url: require("@/assets/emoji/emoji_26.png"),
    name: "睡着",
  },
  {
    value: "[口罩]",
    regexp: "\\[口罩\\]",
    url: require("@/assets/emoji/emoji_27.png"),
    name: "口罩",
  },
  {
    value: "[努力]",
    regexp: "\\[努力\\]",
    url: require("@/assets/emoji/emoji_28.png"),
    name: "努力",
  },
  {
    value: "[抠鼻孔]",
    regexp: "\\[抠鼻孔\\]",
    url: require("@/assets/emoji/emoji_29.png"),
    name: "抠鼻孔",
  },
  {
    value: "[疑问]",
    regexp: "\\[疑问\\]",
    url: require("@/assets/emoji/emoji_30.png"),
    name: "疑问",
  },
  {
    value: "[怒骂]",
    regexp: "\\[怒骂\\]",
    url: require("@/assets/emoji/emoji_31.png"),
    name: "怒骂",
  },
  {
    value: "[晕]",
    regexp: "\\[晕\\]",
    url: require("@/assets/emoji/emoji_32.png"),
    name: "晕",
  },
  {
    value: "[呕吐]",
    regexp: "\\[呕吐\\]",
    url: require("@/assets/emoji/emoji_33.png"),
    name: "呕吐",
  },
  {
    value: "[强]",
    regexp: "\\[强\\]",
    url: require("@/assets/emoji/emoji_34.png"),
    name: "强",
  },
  {
    value: "[弱]",
    regexp: "\\[弱\\]",
    url: require("@/assets/emoji/emoji_35.png"),
    name: "弱",
  },
  {
    value: "[OK]",
    regexp: "\\[OK\\]",
    url: require("@/assets/emoji/emoji_36.png"),
    name: "OK",
  },
  {
    value: "[拳头]",
    regexp: "\\[拳头\\]",
    url: require("@/assets/emoji/emoji_37.png"),
    name: "拳头",
  },
  {
    value: "[胜利]",
    regexp: "\\[胜利\\]",
    url: require("@/assets/emoji/emoji_38.png"),
    name: "胜利",
  },
  {
    value: "[鼓掌]",
    regexp: "\\[鼓掌\\]",
    url: require("@/assets/emoji/emoji_39.png"),
    name: "鼓掌",
  },
  {
    value: "[发怒]",
    regexp: "\\[发怒\\]",
    url: require("@/assets/emoji/emoji_40.png"),
    name: "发怒",
  },
  {
    value: "[骷髅]",
    regexp: "\\[骷髅\\]",
    url: require("@/assets/emoji/emoji_41.png"),
    name: "骷髅",
  },
  {
    value: "[便便]",
    regexp: "\\[便便\\]",
    url: require("@/assets/emoji/emoji_42.png"),
    name: "便便",
  },
  {
    value: "[火]",
    regexp: "\\[火\\]",
    url: require("@/assets/emoji/emoji_43.png"),
    name: "火",
  },
  {
    value: "[溜]",
    regexp: "\\[溜\\]",
    url: require("@/assets/emoji/emoji_44.png"),
    name: "溜",
  },
  {
    value: "[爱心]",
    regexp: "\\[爱心\\]",
    url: require("@/assets/emoji/emoji_45.png"),
    name: "爱心",
  },
  {
    value: "[心碎]",
    regexp: "\\[心碎\\]",
    url: require("@/assets/emoji/emoji_46.png"),
    name: "心碎",
  },
  {
    value: "[钟情]",
    regexp: "\\[钟情\\]",
    url: require("@/assets/emoji/emoji_47.png"),
    name: "钟情",
  },
  {
    value: "[唇]",
    regexp: "\\[唇\\]",
    url: require("@/assets/emoji/emoji_48.png"),
    name: "唇",
  },
  {
    value: "[戒指]",
    regexp: "\\[戒指\\]",
    url: require("@/assets/emoji/emoji_49.png"),
    name: "戒指",
  },
  {
    value: "[钻石]",
    regexp: "\\[钻石\\]",
    url: require("@/assets/emoji/emoji_50.png"),
    name: "钻石",
  },
  {
    value: "[太阳]",
    regexp: "\\[太阳\\]",
    url: require("@/assets/emoji/emoji_51.png"),
    name: "太阳",
  },
  {
    value: "[有时晴]",
    regexp: "\\[有时晴\\]",
    url: require("@/assets/emoji/emoji_52.png"),
    name: "有时晴",
  },
  {
    value: "[多云]",
    regexp: "\\[多云\\]",
    url: require("@/assets/emoji/emoji_53.png"),
    name: "多云",
  },
  {
    value: "[雷]",
    regexp: "\\[雷\\]",
    url: require("@/assets/emoji/emoji_54.png"),
    name: "雷",
  },
  {
    value: "[雨]",
    regexp: "\\[雨\\]",
    url: require("@/assets/emoji/emoji_55.png"),
    name: "雨",
  },
  {
    value: "[雪花]",
    regexp: "\\[雪花\\]",
    url: require("@/assets/emoji/emoji_56.png"),
    name: "雪花",
  },
  {
    value: "[汗]",
    regexp: "\\[汗\\]",
    url: require("@/assets/emoji/emoji_145.png"),
    name: "汗",
  },
  {
    value: "[拜一拜]",
    regexp: "\\[拜一拜\\]",
    url: require("@/assets/emoji/emoji_160.png"),
    name: "拜一拜",
  },
  {
    value: "[惊喜]",
    regexp: "\\[惊喜\\]",
    url: require("@/assets/emoji/emoji_161.png"),
    name: "惊喜",
  },
  {
    value: "[流汗]",
    regexp: "\\[流汗\\]",
    url: require("@/assets/emoji/emoji_162.png"),
    name: "流汗",
  },
  {
    value: "[卖萌]",
    regexp: "\\[卖萌\\]",
    url: require("@/assets/emoji/emoji_163.png"),
    name: "卖萌",
  },
  {
    value: "[默契眨眼]",
    regexp: "\\[默契眨眼\\]",
    url: require("@/assets/emoji/emoji_164.png"),
    name: "默契眨眼",
  },
  {
    value: "[烧香拜佛]",
    regexp: "\\[烧香拜佛\\]",
    url: require("@/assets/emoji/emoji_165.png"),
    name: "烧香拜佛",
  },
  {
    value: "[晚安]",
    regexp: "\\[晚安\\]",
    url: require("@/assets/emoji/emoji_166.png"),
    name: "晚安",
  },
  {
    value: "[握手]",
    regexp: "\\[握手\\]",
    url: require("@/assets/emoji/emoji_167.png"),
    name: "握手",
  },
];
export default emojiList;
